import { wave, waveV3 } from './config';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
import User from '@/store/user';

export const GIFTS_DEFAULT_PAGE_SIZE = 40;

export async function getV3GiftsPaginated(resource, locale) {
  const res = await wave.get('/v3/gifts', {
    params: {
      sort: 'position|asc',
      pageNumber: 0,
      pageSize: GIFTS_DEFAULT_PAGE_SIZE,
      ...resource,
    },
    headers: { 'Accept-Language': locale },
  });

  return res.data;
}

export async function getV3Gifts(resource, locale) {
  const response = await wave.get('/v3/gifts', {
    params: {
      sort: 'position|asc',
      pageNumber: 0,
      pageSize: GIFTS_DEFAULT_PAGE_SIZE,
      ...resource,
    },
    headers: { 'Accept-Language': locale },
  });

  return response.data?.data ? [...response.data?.data] : [];
}

export async function getGiftDetailsV3(giftId, locale) {
  const { data } = await wave.get(`/v3/gifts/${giftId}/details`, {
    headers: { 'Accept-Language': locale },
  });
  return data;
}
export async function getGiftInfoV3(giftId, locale) {
  const { data } = await wave.get(`/v3/gifts/${giftId}`, {
    headers: { 'Accept-Language': locale },
  });

  return data;
}

export async function submitGiftOrder(giftId, deliveryOption, comments, shopId) {
  const authorization = cookies.get('token');
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  const body = {
    ...(shopId && { shopId }),
    deliveryOption,
    comments: comments || '',
    items: [{ giftId, comments: '' }],
  };

  try {
    const response = await waveV3.post('/gift-orders', body, { headers });
    const orderFetched = response?.data;

    User._lazyUserObjectRefresh();

    return orderFetched;
  } catch (error) {
    return { error };
  }
}
